"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EditIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", height: "24", viewBox: "0 0 24 24", width: "24" }, props),
        react_1.default.createElement("path", { fill: 'currentColor', d: "M6.002 18L10 22l-5 1 1.002-5zm12-12L22 10 10.996 21 7 16.997 18.002 6zm4.571-1.418l.132.123.584.584h.003l.123.133c.78.906.778 2.252-.005 3.156l-.123.132-.29.29L19 4.997l.296-.295c.9-.895 2.33-.935 3.277-.12z" })));
};
exports.default = EditIcon;
